import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../../services/util/error.service'
import * as AjudanteHttp from '../../../../../services/api/https/registration/ajudante.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_ASSISTANT: 'Salvando informações do ajudante',
  SUCCESS: 'Salvo com sucesso',
}

const INITIAL_ASSISTANT = {
  id: undefined,
  name: '',
  tp_id: 0,
  cpf: '',
  phone: '(__)_____-____',
  address: '',
  actived: true,
}

const INITIAL_STATE = {
  ajudante: { ...INITIAL_ASSISTANT },
  savedAjudante: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useAjudanteModal() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    // Helpers
    function formatAssistantToPost({ created_at, updated_at, ...ajudanteWithoutDBTimeStamp }) {
      const { phone, name, address, cpf } = ajudanteWithoutDBTimeStamp

      const formattedAjudante = {
        ...ajudanteWithoutDBTimeStamp,
        name: name ? name.trim() : '',
        cpf: cpf ? cpf.trim() : '',
        address: address ? address.trim() : '',
        phone:
          phone !== '' && phone !== '(__)_____-____' && phone
            ? phone.replace('(', '').replace(')', '').replace('-', '')
            : '',
      }
      return formattedAjudante
    }

    return {
      // Actions
      saveAjudante(ajudante, selectedTp) {
        const payload = formatAssistantToPost(ajudante)
        AjudanteHttp.saveAjudante({ ...payload, tp_id: selectedTp })
          .then(ajudanteRes =>
            setState(prevState => ({
              ...prevState,
              savedAjudante: ajudanteRes,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          ajudante: { ...INITIAL_ASSISTANT },
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      resetErrorMessage() {
        setState(prevState => ({ ...prevState, errorMessage: null }))
      },

      validateValue(value) {
        return value ? value : ''
      },

      // Events
      onInit(ajudante) {
        if (ajudante)
          setState(prevState => {
            prevState.ajudante = { ...INITIAL_ASSISTANT, ...ajudante }
            prevState.ajudante.phone =
              !ajudante.phone || ajudante.phone.trim() === ''
                ? INITIAL_ASSISTANT.phone
                : prevState.ajudante.phone
            return { ...prevState }
          })
        else {
          setState(prevState => {
            prevState.ajudante = { ...INITIAL_ASSISTANT }
            return { ...prevState }
          })
        }
      },

      onInputChange(name, value) {
        setState(prevState => {
          prevState.ajudante[name] = value
          return { ...prevState }
        })
      },

      onBtnSalvarClicked(selectedTp) {
        setState(prevState => {
          const { name } = prevState.ajudante

          if (!selectedTp || selectedTp === 0) {
            return { ...prevState, errorMessage: 'Selecione o Operador Logístico' }
          } else if (!name || name.trim() === '') {
            return { ...prevState, errorMessage: 'O campo Nome é obrigatório' }
          } else {
            return { ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_ASSISTANT }
          }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
